import cx from 'classnames'
import Styles from './SEOPlanningWizard.module.scss'
import Table from 'components/BlazeTable/BlazeTable'
import { KeywordData } from './KeywordsResponseType'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface KeywordRowProps {
  item: KeywordData
  maxSearchVolume: number
  isSelected: boolean
  toggleKeyword: (keyword: string) => void
  isCheckbox?: boolean
}

interface BasicKeywordRowProps {
  keyword: string
  isSelected: boolean
  toggleKeyword: (keyword: string) => void
  isCheckbox?: boolean
}

export const KeywordRow = ({
  item,
  maxSearchVolume,
  isSelected,
  toggleKeyword,
  isCheckbox = false,
}: KeywordRowProps) => {
  const { isMobile } = useResponsiveDesign()

  const formatNumber = (num: number) => {
    if (num >= 1000) {
      return Intl.NumberFormat('en-US', { notation: 'compact' }).format(num).toLowerCase()
    } else {
      return '<1k'
    }
  }

  const difficultyColor = (difficulty: number) => {
    if (difficulty < 30) {
      return Styles.green
    } else if (difficulty < 60) {
      return Styles.yellow
    } else {
      return Styles.red
    }
  }

  return (
    <Table.Tr
      key={item.keyword}
      className={cx({ [Styles.selectedRow]: isSelected })}
      onClick={() => toggleKeyword(item.keyword)}
    >
      <Table.Td>
        <div className={Styles.keywordCell}>
          {isCheckbox ? <Checkbox size="lg" isSelected={isSelected} /> : <RadioBullet isSelected={isSelected} />}
          <span>{item.keyword}</span>
        </div>
      </Table.Td>
      <Table.Td maxWidth={isMobile ? '66px' : '148px'}>
        <div className={Styles.searchVolume}>
          <div
            className={Styles.searchVolumeBar}
            style={{
              width: `${Math.max((item.keyword_info.search_volume / maxSearchVolume) * 100, 4)}%`,
            }}
          />
          <span className={Styles.searchVolumeText}>{formatNumber(item.keyword_info.search_volume)}</span>
        </div>
      </Table.Td>
      <Table.Td maxWidth="66px">
        <div className={cx(Styles.keywordDifficulty, difficultyColor(item.keyword_properties.keyword_difficulty))}>
          <div className={Styles.circle} />
          <span className={Styles.difficulty}>{item.keyword_properties.keyword_difficulty}</span>
        </div>
      </Table.Td>
    </Table.Tr>
  )
}

export const BasicKeywordRow = ({ keyword, isSelected, toggleKeyword, isCheckbox = false }: BasicKeywordRowProps) => {
  return (
    <Table.Tr key={keyword} onClick={() => toggleKeyword(keyword)}>
      <Table.Td>
        <div className={Styles.keywordCell}>
          {isCheckbox ? <Checkbox size="lg" isSelected={isSelected} /> : <RadioBullet isSelected={isSelected} />}
          <span>{keyword}</span>
        </div>
      </Table.Td>
    </Table.Tr>
  )
}
